 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import GODSSECRETARIES_COVER from '@/components/godssecretaries_cover'
 import LOVE_1 from '@/components/love_1'
 import GODSSECRETARIES from '@/components/godssecretaries'
 import CONTENTS from '@/components/contents'
 import PERFACE from '@/components/perface'
 import CH01 from '@/components/ch01'
 import CH02 from '@/components/ch02'
 import CH03 from '@/components/ch03'
 import CH04 from '@/components/ch04'
 import CH05 from '@/components/ch05'
 import CH06 from '@/components/ch06'
 import CH07 from '@/components/ch07'
 import CH08 from '@/components/ch08'
 import CH09 from '@/components/ch09'
 import CH10 from '@/components/ch10'
 import CH11 from '@/components/ch11'
 import CH12 from '@/components/ch12'
 import LOVE_2 from '@/components/love_2'
 import APPENDICES from '@/components/appendices'
 import SIXTEENTHCENTURY from '@/components/sixteenthcentury'
 import SIXCOMPANIES from '@/components/sixcompanies'
 import CCHRONOLOGY from '@/components/cchronology'
 import SELECTBIBLIOGRAPHY from '@/components/selectbibliography'
 import INDEX from '@/components/index'
 import ABOUTAUTHOR from '@/components/aboutauthor'
 import PRAISE from '@/components/praise'
 import CREDITS from '@/components/credits'
 import COPYRIGHT from '@/components/copyright'
 import ABOUTPUBLISHER from '@/components/aboutpublisher'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/godssecretaries_cover",
 			"name" : "godssecretaries_cover",
 			"component" : GODSSECRETARIES_COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/godssecretaries",
 			"name" : "godssecretaries",
 			"component" : GODSSECRETARIES
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/perface",
 			"name" : "perface",
 			"component" : PERFACE
 		},
 		{
 			"path" : "/ch01",
 			"name" : "ch01",
 			"component" : CH01
 		},
 		{
 			"path" : "/ch02",
 			"name" : "ch02",
 			"component" : CH02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js